const TARGET_AMOUNT = {
  dataAid: "customGoal",
  header: {
    dataAid: "amountDetails",
    title: "Amount details",
  },
  investmentCard: {
    dataAid: "saveForAGoal",
    amountTitle: { text: "Enter target amount" },
    inputPlaceholder: "Enter amount",
  },
  footer: {
    text: "NEXT",
    dataAid: "primary",
  },
};

export default TARGET_AMOUNT;
